/**
 * JavsScript used by Video and Photo Galleries V2 
 */

/**
 * Helper function to initialize any Video and Photo Gallery modules
 * 
 * NOTE: there is a click listener in app.js for .view-photos-btn that handles forcing
 * lazy loading of images within the associated reveal modal when the button to open it
 * is clicked. Also, be aware of initMediaModals in app.js as well as it pauses and 
 * reset videos in modals
 */

import {
    initWidenVideos,
    reloadWidenVideo,
    resetWidenVideo
} from './lib/widen-media.js'
// let Swiper = require("./vendors/swiper-bundle.js");
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import observer from './observer.js';

// import styles bundle
//import 'swiper/css/bundle';


function initModalCarouselV2() {
    // find the modal galleries that have slick carousels that have not been initialized yet
    var uninitialzedModalCarousels = $("[data-is-modal-carousel-initialized='0']");
    if (uninitialzedModalCarousels.length) {
        // Run foundation init (these are [data-reveal] elements therefore we need foundation to initialize reveal)
        uninitialzedModalCarousels.foundation();

        // Trigger the lazy load of images within this modal
        window.triggerLazyLoadRevealImages(uninitialzedModalCarousels);

        $.each(uninitialzedModalCarousels, (index, uninitialzedModalCarousel) => {
            const OPEN_REVEAL_EVENT = 'open.zf.reveal';
            $(uninitialzedModalCarousel).off(OPEN_REVEAL_EVENT).on(OPEN_REVEAL_EVENT, function (event) {

                const MODAL = $(event.target);
                MODAL.find('.dialog-video').each((videoEl) => {
                    new Plyr(videoEl);
                });
    
                const MODAL_CAROUSEL = MODAL.find('[data-dialog-gallery-carousel]');
                const MODAL_CAROUSEL_NAV = MODAL.find('[data-dialog-gallery-nav]');
                const IS_MODAL_CAROUSEL_INITIALIZED = MODAL.attr("data-is-modal-carousel-initialized");

                if (IS_MODAL_CAROUSEL_INITIALIZED == "0") {
                    MODAL_CAROUSEL.slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: "600",
                        infinite: true,
                        useTransform: false,
                        asNavFor: MODAL_CAROUSEL_NAV,
                        mobileFirst: true,
                        fade: true,
                        arrows: true,
                        lazyLoad: "ondemand",
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false
                                }
                            }
                        ]
                    });
                    MODAL_CAROUSEL_NAV.slick({
                        slidesToShow: 8,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '10px',
                        asNavFor: MODAL_CAROUSEL,
                        infinite: true,
                        useTransform: false,
                        focusOnSelect: true,
                        mobileFirst: true,
                        lazyLoad: "ondemand",
                    });
        
                    slideCounterArrowRemoval(MODAL_CAROUSEL);
                    slickSlidePrevNext(MODAL_CAROUSEL);
                }

                // Set the initialized flag on the .data-modal-gallery.data-reveal modal
                MODAL.attr("data-is-modal-carousel-initialized", "1");
    
                
                
                // before slide change pause any videos playing
                const BEFORE_AFTER_CHANGE_REVEAL_EVENT = 'beforeChange afterChange';
                MODAL_CAROUSEL.off(BEFORE_AFTER_CHANGE_REVEAL_EVENT).on(BEFORE_AFTER_CHANGE_REVEAL_EVENT, function (event, slick, currentSlide, nextSlide) {
                    var currentSlide = $(this).find('.slick-slide');
    
                    // Pause all videos in this carousel
                    currentSlide.find("video").each(function (index, elem) {
                        var video = elem;
    
                        if ($(video).length > 0) {
                            $(video).get(0).pause();
    
                        }
                    });
                });
                // before slide change pause iframe videos playing on the background
                const BEFORE_CHANGE_MODAL_EVENT = 'beforeChange';
                MODAL_CAROUSEL.on(BEFORE_CHANGE_MODAL_EVENT, function (event, slick, currentSlide, nextSlide) {
                  var $currentSlideElement = $(slick.$slides.get(currentSlide));
 
                    $currentSlideElement.find("iframe").each(function (index, elem) {
                        initWidenVideos(elem);
                    });
                  });
                 
            });

            const CLOSED_REVEAL_EVENT = 'closed.zf.reveal';
            $(uninitialzedModalCarousel).off(CLOSED_REVEAL_EVENT).on(CLOSED_REVEAL_EVENT, function (event) {
                // on close, pause all videos in media modals
                var videos = document.querySelectorAll('.media-modal iframe, .media-modal video');
                Array.prototype.forEach.call(videos, function () {
                });
                const MODAL = $(event.target);    
                const MODAL_CAROUSEL = MODAL.find('[data-dialog-gallery-carousel]');
                const MODAL_CAROUSEL_NAV = MODAL.find('[data-dialog-gallery-nav]');
                MODAL_CAROUSEL.slick('unslick');
                MODAL_CAROUSEL_NAV.slick('unslick');
                MODAL.attr("data-is-modal-carousel-initialized", "0");
            });

            
            // // Set the initialized flag on the .data-modal-gallery.data-reveal modal
            // uninitialzedModalCarousel.attr("data-is-modal-carousel-initialized", "1");
        })

    }
    
}

function slideCounterArrowRemoval(carouselId) {
    const MAX_SLIDES_TO_CENTER = 8;
    const MIN_SLIDES_TO_CENTER = 1;
    let car = $(carouselId).find('.slide-container');
    //just to count how many slides a carousel has and remove them if there is only one slide
    let numb = $(car).length;
    if (numb == MIN_SLIDES_TO_CENTER) {
        $(".slick-arrow").css("display", "none");
    } else {
        $(".slick-arrow").css("display", "block");
    }
    //centers the slick track when there is less than 8 to prevent issues with default slick behaviour
    if (numb <= MAX_SLIDES_TO_CENTER){
        $(".slick-track").addClass("center-track")
    }
}

function slickSlidePrevNext(carosuelId) {
    //JS to trigger the slider functions when thumbnails are available
    const CAROUSEL_ELEM = carosuelId,
        NEXT_BUTTON = $('.slick-next'),
        PREV_BUTTON = $('.slick-prev');

    NEXT_BUTTON.on('click', function () {
        CAROUSEL_ELEM.slick('slickNext')
    });
    PREV_BUTTON.on('click', function () {
        CAROUSEL_ELEM.slick('slickPrev')
    });
}

function pauseIframeVideo(currentSlide){
    // toggles the source of all iframe in this carousel
    currentSlide.find("iframe").each(function (index, elem) {
        initWidenVideos(elem);
    });
}

const withSlickInit = async () => {
    await import(/* webpackChunkName: "foundation-sites" */"foundation-sites");
    await import(/* webpackChunkName: "plyr" */"plyr");
    import(/* webpackChunkName: "slick-carousel" */"slick-carousel");

    initModalCarouselV2();
};

window.initModalCarouselV2 = withSlickInit;

/**
 * Initializes the swiper instance and sets up lazy loading for the video iframe
 * in the active slide.
 *
 * @param {Object} swiper - The swiper instance containing slides and their states.
 */
function swiperInitHandler(swiper) {
    let curSlide = swiper.slides[swiper.activeIndex];
    let currentIframe = curSlide.querySelector("iframe");
    // This is the initial state of the slider, lazy load its video
    if(currentIframe) {
        observer(currentIframe, () => {
            const dataIframeSrc = currentIframe.getAttribute("data-iframe-src");
            currentIframe.setAttribute("src", dataIframeSrc);
        })
    }
}

/**
 * Handles the transition end event for the swiper, managing the accessibility
 * by removing inactive slides from tabbing order.
 *
 * @param {Object} swiper - The swiper instance containing slides and their states.
 */
function swiperTransitionEndHandler(swiper) {
    removeInactiveSlidesFromTabbing(swiper.slides);
}

/**
 * Manages slide changes in the swiper instance and updates iframe video sources
 * to manage video playback behavior when slides change.
 *
 * @param {Object} swiper - The swiper instance containing slides and their states.
 */
function swiperSlideChangeHandler(swiper) {
    let previousSlide = swiper.slides[swiper.previousIndex];
    let curSlide = swiper.slides[swiper.activeIndex];
    
    let previousIframe = previousSlide.querySelector("iframe");
    let currentIframe = curSlide.querySelector("iframe");

    // Typical current frame behavior after user interaction
    if(currentIframe && swiper.activeIndex != swiper.previousIndex) {
      const dataIframeSrc = currentIframe.getAttribute("data-iframe-src");
      currentIframe.setAttribute("src", dataIframeSrc);
    }

    // make this this a slide change not stemming from the intial loading
    // library will treat initial rendering as a slide change
    if (previousIframe && swiper.activeIndex != swiper.previousIndex) {
        // to prevent video from playing in background after
        // slide change reload it so that it effectively pauses
        // video playback harshly.
        previousIframe.removeAttribute("src");
    }
}

/**
 * Expectation is that the referenced element contains `.media-carousel` and `.media-thumbnail-carousel`
 * child elements
 * @param {*} mediaWithThumbnailsCarouselElem 
 */
export function initMediaWithThumbnailCarousel(mediaWithThumbnailsCarouselElem){

    let thumbnailCarouselElem = mediaWithThumbnailsCarouselElem.querySelector(".media-thumbnail-carousel");
    let mediaCarouselElem = mediaWithThumbnailsCarouselElem.querySelector(".media-carousel");

    // Init the Thumbnail Swiper
    var thumbnailSwiper = new Swiper(thumbnailCarouselElem, {
        loop: true,
        spaceBetween: 16,
        slidesPerView: 8.3,
        slidesPerGroup: 8,
        freeMode: true,
        watchSlidesProgress: true,
        autoheight: true
    });

    // Determine whether or not we need to configure the navigation buttons, and if we do need 
    // them, build the navigation configuration object
    let useNavigation = mediaCarouselElem.querySelectorAll(".swiper-slide").length > 1;
    let navigationSetting = (useNavigation && {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    });

    // Init the Media Swiper
    const mediaSwiper = new Swiper(mediaCarouselElem, {
        loop: true,
        spaceBetween: 10,
        navigation: navigationSetting,
        thumbs: {
            swiper: thumbnailSwiper,
        },
        init: false // mediaSwiper is manually initialized below
    });

    mediaSwiper.on("init", swiperInitHandler);

    // Manually init with "init" handler (above), see https://swiperjs.com/swiper-api#event-init
    mediaSwiper.init();

    mediaSwiper.on("transitionEnd", swiperTransitionEndHandler);

    mediaSwiper.on("slideChange", swiperSlideChangeHandler);
}
window.initMediaWithThumbnailCarousel = initMediaWithThumbnailCarousel;

/**
 * 
 * @param {*} slides 
 */
function removeInactiveSlidesFromTabbing(slides) {
    slides.forEach(function (slide, index) {
        // reset tabindex before we set it for inactive slides
        $(slide).attr("tabindex", undefined);

        // set the tabindex to -1 for inactive slides
        if (!$(slide).hasClass('swiper-slide-active')) {
            setTimeout(() => {
                
                $(slide).attr("tabindex", -1);
                $(slide).find('*').attr("tabindex", -1);
            }, 500);
        }
        else {
            setTimeout(() => {
                $(slide).find("iframe").attr("tabindex", 0);
            }, 500);
            
        }
    });
}

/**
 * Initialize the carousels WITHIN the reference parentElem
 * @param {*} parentElem Parent Element containing carousel(s) within it
 */
export function initMediaWithThumbnailCarousels(parentElem) {
    if (!parentElem ) {
        return;
    }

    let swiperMediaCarousels = parentElem.querySelectorAll(".media-with-thumbnails-carousel");
    if (swiperMediaCarousels && swiperMediaCarousels.length > 0) {
        swiperMediaCarousels.forEach(carousel => {
            initMediaWithThumbnailCarousel(carousel);
        });
    }
}
window.initMediaWithThumbnailCarousels = initMediaWithThumbnailCarousels;

/**
 * Expectation is that the referenced element contains `.media-carousel`
 * child elements
 * @param {*} parentElem 
 */
export function initMediaCarousel(parentElem){

    let mediaCarouselElem = parentElem.querySelector(".media-carousel");

    // Determine whether or not we need to configure the navigation buttons, and if we do need 
    // them, build the navigation configuration object
    let useNavigation = mediaCarouselElem.querySelectorAll(".swiper-slide").length > 1;
    let navigationSetting = (useNavigation && {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    });

    var mediaSwiper = new Swiper(mediaCarouselElem, {
        loop: true,
        spaceBetween: 10,
        navigation: navigationSetting,
        init: false, // See manual init below
    });

    mediaSwiper.on("init", swiperInitHandler);

    // Manually init with "init" handler (above), see https://swiperjs.com/swiper-api#event-init
    mediaSwiper.init();

    mediaSwiper.on("transitionEnd", swiperTransitionEndHandler);

    mediaSwiper.on("slideChange", swiperSlideChangeHandler);
}
window.initMediaCarousel = initMediaCarousel;
